import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import TarotReadingDeckCard from './deck-card';
import _ from 'underscore';

class Component extends BaseComponent {
    componentDidMount() {
        if (this.props.upc && this.props.upc.match(/^two-hearts-.*/)) {
            const spread = _.chain(this.props.cards)
                .filter(card => card.index < 22)
                .pluck('index')
                .shuffle()
                .value();

            this.props.updateSpread(spread);
        }
    }

    render({ spread }) {
        if (spread) {
            return (
                <tarot-reading-deck>
                    {_.map(spread, key => this.renderCard(key))}
                </tarot-reading-deck>
            );
        }

        return (<tarot-reading-deck />);
    }

    renderCard = (card_id) => {
        if (card_id) {
            return (
                <TarotReadingDeckCard
                    card_id={card_id}
                    upsell={this.props.upsell}
                    upc={this.props.upc}
                    view={this.props.view}
                />
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    cards: state.deck && state.deck.cards,
    spread: state.spread,
    upc: state.product && state.product.description && state.product.description.slug,
});

const mapDispatchToProps = (dispatch) => ({
    updateSpread: (payload) => dispatch({
        type: 'spread:update',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
